import React from 'react';
import { useSearchableReservationPartiesLookupQuery } from '../../Reservation/Service/reservationPartiesLookupApi';
import type {
  BookingReservationPartyLookup,
  BookingReservationPartyLookupRequest,
} from '../Types/bookingReservationTable.types';
import { mapBookingReservationPartiesLookup } from './bookingReservationPartiesLookupApi.contract';

export const useSearchableBookingReservationPartiesLookupQuery = (
  request?: BookingReservationPartyLookupRequest
): {
  parties: BookingReservationPartyLookup[];
  isLoading: boolean;
} => {
  const queryResult = useSearchableReservationPartiesLookupQuery(request);

  const parties = React.useMemo(
    () => mapBookingReservationPartiesLookup(queryResult.parties),
    [queryResult.parties]
  );

  return {
    parties,
    isLoading: queryResult.isLoading,
  };
};
